<p-panel [collapsed]="true" [toggleable]="true" header="Посещение по дням">
  <p-table [value]="data" [rowHover]="true" [responsive]="true" [paginator]="true" [rows]="10" [pageLinks]="3"
    [rowsPerPageOptions]="[5, 10, 20, 50, 100]" [showCurrentPageReport]="true" [currentPageReportTemplate]="'{first} - {last} / {totalRecords}'">
    <ng-template pTemplate="header">
      <tr>
        <th class="text-center" style="padding: 0.5rem 1rem">День</th>
        <th class="text-center" style="padding: 0.5rem 1rem">
          Зарегистр.
        </th>
        <th class="text-center" style="padding: 0.5rem 1rem">Прибыло</th>
        <th class="text-center" style="padding: 0.5rem 1rem">НМО</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr class="hover:bg-gray-50">
        <td class="text-center" style="padding: 0.5rem 1rem">
          {{ item.day }}
        </td>
        <td class="text-center" style="padding: 0.5rem 1rem">
          {{ item.registered }}
        </td>
        <td class="text-center" style="padding: 0.5rem 1rem">
          {{ item.arrived }}
        </td>
        <td class="text-center" style="padding: 0.5rem 1rem">
          {{ item.nmo }}
        </td>
      </tr>
    </ng-template>
  </p-table>
  <ng-template pTemplate="footer">
    <p-button label="Excel" styleClass="p-button-secondary" (click)="onExcelDays(data)"></p-button>
  </ng-template>
</p-panel>
